"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightDirectAdditional = function SvgFlightDirectAdditional(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136 14",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B5A48B",
    d: "M8 10s19.85-3 63-3 63 3 63 3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 10.5,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#877C68",
    d: "M19 5c10.275-2.201 30.811-5 50.027-5C112.16 0 132 10 132 10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    d: "m7.193 8.793-2.405 1.403s-.639.472-1.843.236S.506 9.936.506 9.936s-.265-.091-.447.134c-.183.225.118.359.118.359l1.857 1.28s.396.373.98.275c.582-.098 2.297-.43 2.297-.43s1.171-.237 2.564-1.064c1.392-.826 6.369-3.699 6.369-3.699s1.936-1.047 1.742-1.486c-.194-.438-1.31-.321-1.844-.16-.534.16-4.702 2.407-4.702 2.407l-4.567-1.49s-.59-.133-.295.195 3.189 3.068 3.189 3.068M9 10.973l1.364.996s.396.23.476-.57C10.92 10.6 11 10 11 10"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlightDirectAdditional);
var _default = Memo;
exports["default"] = _default;